import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { toast } from "react-toastify";

import { useStartQuizAttemptMutation } from "../../../slices/quizAttemptApiSlice";

const StartQuizButton = ({
  quizId,
  disabled,
  onStarted,
}) => {
  const navigate = useNavigate();

  const [startQuizAttempt, { isLoading: startingQuiz }] =
    useStartQuizAttemptMutation();


  const handleStartQuiz = async () => {

    if (disabled) {
      toast.error(
        "Question availability is insufficient."
      );
      return;
    }

    try {

      const response = await startQuizAttempt(quizId).unwrap();

      if (onStarted) {
        onStarted(response);
      }

      navigate(`/student/attempt/${response.attemptId}`);

    } catch (error) {

      toast.error(
        error?.data?.message ||
        "Unable to start quiz"
      );

    }
  };


  return (
    <button
      type="button"
      onClick={handleStartQuiz}
      disabled={startingQuiz || disabled}
      className="
        rounded-xl
        bg-blue-600
        px-6
        py-3
        font-semibold
        text-white
        shadow
        hover:bg-blue-700
        disabled:opacity-50
      "
    >
      {startingQuiz
        ? "Generating Question Paper..."
        : "Start Quiz"}
    </button>
  );
};


StartQuizButton.propTypes = {
  quizId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onStarted: PropTypes.func,
};


export default StartQuizButton;